<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    html,body{
        margin:0px;
        padding:0px;
        height:100%;
        background:#f6f9ff;
    }
    #app{
        height:100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue